/**
 * 問い合わせメッセージ
 */
export default interface ContactMessage {
  /** Case ID。1から始まる数値の連番 */
  caseId: number;
  /** 作成日時。お問合せ／回答の送信日時(YYYYMMDDhhmmssmm)も兼ねる */
  created: number;
  /** 問い合わせ元施設を特定する ID */
  facilityId: number;
  /** 送信者(施設 or Konicaminolta担当者)を特定するID */
  sender: string;
  /** 送信者(施設 or Konicaminolta担当者)の名前 */
  senderName: string;
  /** 送信種別(0:問い合わせ、1:回答) */
  sendType: SendType;
  /** 問い合わせ／回答内容 */
  message: string;
  /** 論理削除フラグ */
  deleteFlag: boolean;
}

/** お問合せの種類 */
export enum SendType {
  /** 問い合わせ */
  QUESTION = 0,
  /** 回答内容 */
  ANSWER = 1
}
